// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  color-scheme: dark;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  --bg: #0b1120;
  --surface: #0f172a;
  --surface-strong: #1e293b;
  --border: #334155;
  --text: #e2e8f0;
  --muted: #94a3b8;
  --muted-strong: #cbd5e1;
  --secondary-color: #4f46e5;
  --button-bg: var(--secondary-color);
  --button-border: var(--secondary-color);
  --button-text: #ffffff;
  --card-shadow: 0 20px 60px rgba(0, 0, 0, 0.9);
  --body-bg: radial-gradient(circle at top, rgba(99, 102, 241, 0.12), transparent 40%), linear-gradient(180deg, #0b1120 0%, #080b15 100%);
  /* server card accent gradient — adjustable via Website Config */
  --accent-start: #22d3ee;
  --accent-end: #34d399;
  /* session progress bar gradient */
  --progress-start: #10b981;
  --progress-end: #22d3ee;
}

/* Use border-box everywhere to avoid unexpected overflow */
*, *::before, *::after {
  box-sizing: border-box;
}

body.light-theme {
  color-scheme: light;
  --bg: #f8fafc;
  --surface: #ffffff;
  --surface-strong: #f1f5f9;
  --border: #e2e8f0;
  --text: #111827;
  --muted: #64748b;
  --muted-strong: #475569;
  --secondary-color: #4338ca;
  --button-bg: var(--secondary-color);
  --button-border: var(--secondary-color);
  --button-text: #ffffff;
  --card-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
  --body-bg: #f8fafc;
}

html, body, #root {
  min-height: 100%;
  margin: 0;
}

body {
  min-height: 100%;
  margin: 0;
  background: var(--body-bg);
  color: var(--text);
}

.app-shell {
  display: grid;
  grid-template-rows: auto 1fr;
  min-height: 100vh;
}

.app-main {
  padding: 24px;
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
}

/* Prevent horizontal overflow on touch devices */
.is-mobile .app-main {
  padding: 16px;
  max-width: 100%;
}

/* Prevent page-level horizontal overflow on touch devices */
.is-mobile {
  overflow-x: hidden;
}

.page-header {
  margin-bottom: 32px;
}

h2, h3, label {
  color: var(--text);
}

.page-header h1 {
  margin: 0 0 12px;
  font-size: clamp(2rem, 2.5vw, 2.75rem);
  font-weight: 700;
  letter-spacing: -0.03em;
  color: var(--text);
}

.page-header p {
  margin: 0;
  color: var(--muted);
  max-width: 760px;
  line-height: 1.6;
}

.section-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 24px;
  box-shadow: var(--card-shadow);
}

.small-button {
  border: 1px solid var(--border);
  background: var(--surface-strong);
  color: var(--text);
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  transition: all 0.2s;
}

.small-button.active,
.small-button:hover {
  background: var(--button-bg);
  color: var(--button-text);
  border-color: var(--button-border);
}

.small-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.social-button-content {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.social-icon {
  width: 14px;
  height: 14px;
  fill: currentColor;
}

.list-grid,
.card-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
}

.card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 20px;
  transition: all 0.2s;
}

.card:hover {
  border-color: var(--muted-strong);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}

.card h3 {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
  color: var(--text);
}

.card p {
  margin: 0;
  font-size: 14px;
  color: var(--muted);
  line-height: 1.5;
}

.table-wrapper {
  overflow-x: auto;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface);
}

/* On touch devices hide horizontal scroll and ensure tables wrap into our mobile layout */
.is-mobile .table-wrapper {
  overflow-x: hidden;
  border: 0px !important;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

tbody tr {
  border-bottom: 1px solid var(--border);
  transition: background-color 0.2s;
}

tbody tr:hover {
  background-color: rgba(51, 65, 85, 0.5);
}

body.light-theme tbody tr:hover {
  background-color: rgba(15, 23, 42, 0.05);
}

td, th {
  text-align: left;
  padding: 14px 16px;
}

th {
  background: var(--surface-strong);
  color: var(--muted-strong);
  font-weight: 600;
  font-size: 13px;
  border-bottom: 1px solid var(--border);
}

td {
  color: var(--text);
}

input, select {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 12px 14px;
  background: var(--surface);
  color: var(--text);
  font-size: 14px;
  transition: border-color 0.2s;
}

input:focus, select:focus {
  outline: none;
  border-color: var(--button-bg);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

input::placeholder,
select::placeholder {
  color: var(--muted);
}

input[type='date'] {
  max-width: 220px;
}

.form-row {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  margin-bottom: 20px;
}

.form-row label {
  display: grid;
  gap: 8px;
  color: var(--text);
  font-size: 14px;
  font-weight: 500;
}

.primary-button {
  appearance: none;
  border: 1px solid var(--button-border);
  background: var(--button-bg);
  color: var(--button-text);
  border-radius: 8px;
  padding: 12px 18px;
  cursor: pointer;
  font-weight: 700;
  font-size: 14px;
  transition: all 0.2s;
}

.toast-stack {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 3000;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.toast {
  position: relative;
  min-width: 240px;
  max-width: 320px;
  border-radius: 12px;
  padding: 12px 40px 12px 14px;
  background: var(--surface);
  border: 1px solid var(--border);
  box-shadow: var(--card-shadow);
}

.toast.success {
  border-color: #22c55e;
}

.toast.error {
  border-color: #ef4444;
}

.toast-close {
  position: absolute;
  top: 8px;
  right: 8px;
  border: 0;
  background: transparent;
  color: var(--muted-strong);
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
}

.toast-title {
  font-weight: 700;
  margin-bottom: 4px;
}

.driver-profile-card {
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 14px;
  background: var(--surface-strong);
}

.driver-profile-socials {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.driver-profile-socials a {
  color: var(--secondary-color);
  font-weight: 600;
}

.primary-button:hover:not(:disabled) {
  background: var(--button-border);
  box-shadow: 0 8px 16px rgba(79, 70, 229, 0.2);
}

.primary-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.empty-state {
  color: var(--muted);
  padding: 40px 20px;
  text-align: center;
  font-size: 15px;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  background: color-mix(in srgb, var(--secondary-color) 16%, transparent);
  color: var(--secondary-color);
}

.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--button-bg);
  color: var(--button-text);
  font-weight: 700;
  font-size: 12px;
}

@media (max-width: 768px) {
  .app-main {
    padding: 16px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .list-grid,
  .card-grid {
    grid-template-columns: 1fr;
  }

  /* Mobile: convert tables into card-like rows with labels */
  table.responsive-table,
  .results-standings-table.responsive-table,
  .table-wrapper {
    border: 0;
  }

  .responsive-table thead {
    display: none;
  }

  .responsive-table tbody tr {
    display: block;
    margin: 10px 0;
    border: 1px solid var(--border);
    border-radius: 8px;
    background: var(--surface-strong);
    padding: 3px;
  }

  .responsive-table td {
    display: flex;
    justify-content: space-between;
    padding: 8px 6px;
    border: none;
  }

  .responsive-table td::before {
    content: attr(data-label);
    color: var(--muted);
    margin-right: 8px;
    flex: 0 0 35%;
    text-align: left;
    font-weight: 600;
  }

  /* Values should be left aligned and sit close to the label */
  .responsive-table td span {
    display: inline-block;
    text-align: left;
    flex: 1 1 auto;
    color: var(--text);
  }
}

/* Drivers table: hide Last Seen (4th column) on small screens */
@media (max-width: 768px) {
  .drivers-condensed thead th:nth-child(4),
  .drivers-condensed tbody td:nth-child(4) {
    display: none;
  }
}

/* Past championships table: hide Start and Races columns on small screens */
@media (max-width: 640px) {
  .past-championships-table thead th:nth-child(2),
  .past-championships-table tbody td:nth-child(2),
  .past-championships-table thead th:nth-child(4),
  .past-championships-table tbody td:nth-child(4) {
    display: none;
  }
}

@media (max-width: 768px) {
  .drivers-condensed tbody tr {
    cursor: pointer;
  }

  .home-hero {
    padding: 18px;
  }

  .home-hero .section-card h1 {
    font-size: 1.6rem;
  }

  .home-hero .primary-button {
    width: 100%;
    padding: 12px 14px;
  }

  .hotlap-responsive tbody tr {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    gap: 2px 4px;
    align-items: center;
    padding: 3x;
    border: 1px solid var(--border);
    border-radius: 8px;
    background: var(--surface-strong);
    margin: 8px 0;
  }

  .hotlap-responsive tbody tr td {
    display: block;
    padding: 4px 6px;
    border: none;
  }

  .hotlap-responsive tbody tr td:nth-child(2) { /* Driver */
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }

  .hotlap-responsive tbody tr td:nth-child(1) { /* Track */
    grid-column: 2 / 3;
    grid-row: 1 / 2;
  }

  .hotlap-responsive tbody tr td:nth-child(3) { /* Car */
    grid-column: 1 / 2;
    grid-row: 2 / 3;
  }

  .hotlap-responsive tbody tr td:nth-child(4) { /* Best Lap */
    grid-column: 2 / 3;
    grid-row: 2 / 3;
    text-align: left;
  }

  /* Reduce badge and position sizes on small screens */
  .position-badge {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }

  .badge {
    min-width: 24px;
    height: 24px;
    font-size: 11px;
  }
}

/* Apply same mobile layout rules when device is touch-enabled */
.is-mobile table.responsive-table,
.is-mobile .results-standings-table.responsive-table {
  border: 0;
}

.is-mobile .responsive-table thead {
  display: none;
}

.is-mobile .responsive-table tbody tr {
  display: block;
  margin: 10px 0;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface-strong);
  padding: 12px;
}

.is-mobile .responsive-table td {
  display: flex;
  justify-content: space-between;
  padding: 8px 6px;
  border: none;
}

.is-mobile .responsive-table td::before {
  content: attr(data-label);
  color: var(--muted);
  margin-right: 8px;
  flex: 0 0 35%;
  text-align: left;
  font-weight: 600;
}

.is-mobile .responsive-table td span {
  display: inline-block;
  text-align: left;
  flex: 1 1 auto;
  color: var(--text);
}

/* Hide unwanted columns (Date, Session) on touch devices for hotlap/recent sessions */
.is-mobile .hotlap-responsive thead th:nth-child(5),
.is-mobile .hotlap-responsive tbody td:nth-child(5),
.is-mobile .hotlap-responsive thead th:nth-child(6),
.is-mobile .hotlap-responsive tbody td:nth-child(6) {
  display: none;
}

/* Also hide Date column in DriverDetail recent sessions (5th column) */
.is-mobile .hotlap-responsive thead th:nth-child(5),
.is-mobile .hotlap-responsive tbody td:nth-child(5) {
  display: none;
}

/* Provide two-row grid layout on touch devices for hotlap rows */
.is-mobile .hotlap-responsive tbody tr {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
  gap: 6px 12px;
  align-items: center;
  padding: 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface-strong);
  margin: 8px 0;
}

.is-mobile .hotlap-responsive tbody tr td {
  display: block;
  padding: 4px 6px;
  border: none;
}

.is-mobile .hotlap-responsive tbody tr td:nth-child(2) { /* Driver */
  grid-column: 1 / 2;
  grid-row: 1 / 2;
}

.is-mobile .hotlap-responsive tbody tr td:nth-child(1) { /* Track */
  grid-column: 2 / 3;
  grid-row: 1 / 2;
}

.is-mobile .hotlap-responsive tbody tr td:nth-child(3) { /* Car */
  grid-column: 1 / 2;
  grid-row: 2 / 3;
}

.is-mobile .hotlap-responsive tbody tr td:nth-child(4) { /* Best Lap */
  grid-column: 2 / 3;
  grid-row: 2 / 3;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB;;cAEY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,mCAAmC;EACnC,uCAAuC;EACvC,sBAAsB;EACtB,6CAA6C;EAC7C,uIAAuI;EACvI,gEAAgE;EAChE,uBAAuB;EACvB,qBAAqB;EACrB,kCAAkC;EAClC,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,2DAA2D;AAC3D;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,mCAAmC;EACnC,uCAAuC;EACvC,sBAAsB;EACtB,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,4BAA4B;EAC5B,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,4DAA4D;AAC9D;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,0FAA0F;AAC1F;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,uEAAuE;EACvE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA,2DAA2D;EAC3D;;;IAGE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,cAAc;IACd,+BAA+B;IAC/B,kBAAkB;IAClB,iCAAiC;IACjC,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,6DAA6D;EAC7D;IACE,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;AACF;;AAEA,gEAAgE;AAChE;EACE;;IAEE,aAAa;EACf;AACF;;AAEA,4EAA4E;AAC5E;EACE;;;;IAIE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,6BAA6B;IAC7B,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,+BAA+B;IAC/B,kBAAkB;IAClB,iCAAiC;IACjC,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;EACd;;EAEA,8CAA8C,WAAW;IACvD,kBAAkB;IAClB,eAAe;EACjB;;EAEA,8CAA8C,UAAU;IACtD,kBAAkB;IAClB,eAAe;EACjB;;EAEA,8CAA8C,QAAQ;IACpD,kBAAkB;IAClB,eAAe;EACjB;;EAEA,8CAA8C,aAAa;IACzD,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA,qDAAqD;EACrD;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,gEAAgE;AAChE;;EAEE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,sFAAsF;AACtF;;;;EAIE,aAAa;AACf;;AAEA,uEAAuE;AACvE;;EAEE,aAAa;AACf;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA,yDAAyD,WAAW;EAClE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yDAAyD,UAAU;EACjE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yDAAyD,QAAQ;EAC/D,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yDAAyD,aAAa;EACpE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[":root {\r\n  color-scheme: dark;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  --bg: #0b1120;\r\n  --surface: #0f172a;\r\n  --surface-strong: #1e293b;\r\n  --border: #334155;\r\n  --text: #e2e8f0;\r\n  --muted: #94a3b8;\r\n  --muted-strong: #cbd5e1;\r\n  --secondary-color: #4f46e5;\r\n  --button-bg: var(--secondary-color);\r\n  --button-border: var(--secondary-color);\r\n  --button-text: #ffffff;\r\n  --card-shadow: 0 20px 60px rgba(0, 0, 0, 0.9);\r\n  --body-bg: radial-gradient(circle at top, rgba(99, 102, 241, 0.12), transparent 40%), linear-gradient(180deg, #0b1120 0%, #080b15 100%);\r\n  /* server card accent gradient — adjustable via Website Config */\r\n  --accent-start: #22d3ee;\r\n  --accent-end: #34d399;\r\n  /* session progress bar gradient */\r\n  --progress-start: #10b981;\r\n  --progress-end: #22d3ee;\r\n}\r\n\r\n/* Use border-box everywhere to avoid unexpected overflow */\r\n*, *::before, *::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody.light-theme {\r\n  color-scheme: light;\r\n  --bg: #f8fafc;\r\n  --surface: #ffffff;\r\n  --surface-strong: #f1f5f9;\r\n  --border: #e2e8f0;\r\n  --text: #111827;\r\n  --muted: #64748b;\r\n  --muted-strong: #475569;\r\n  --secondary-color: #4338ca;\r\n  --button-bg: var(--secondary-color);\r\n  --button-border: var(--secondary-color);\r\n  --button-text: #ffffff;\r\n  --card-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);\r\n  --body-bg: #f8fafc;\r\n}\r\n\r\nhtml, body, #root {\r\n  min-height: 100%;\r\n  margin: 0;\r\n}\r\n\r\nbody {\r\n  min-height: 100%;\r\n  margin: 0;\r\n  background: var(--body-bg);\r\n  color: var(--text);\r\n}\r\n\r\n.app-shell {\r\n  display: grid;\r\n  grid-template-rows: auto 1fr;\r\n  min-height: 100vh;\r\n}\r\n\r\n.app-main {\r\n  padding: 24px;\r\n  max-width: 1280px;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n}\r\n\r\n/* Prevent horizontal overflow on touch devices */\r\n.is-mobile .app-main {\r\n  padding: 16px;\r\n  max-width: 100%;\r\n}\r\n\r\n/* Prevent page-level horizontal overflow on touch devices */\r\n.is-mobile {\r\n  overflow-x: hidden;\r\n}\r\n\r\n.page-header {\r\n  margin-bottom: 32px;\r\n}\r\n\r\nh2, h3, label {\r\n  color: var(--text);\r\n}\r\n\r\n.page-header h1 {\r\n  margin: 0 0 12px;\r\n  font-size: clamp(2rem, 2.5vw, 2.75rem);\r\n  font-weight: 700;\r\n  letter-spacing: -0.03em;\r\n  color: var(--text);\r\n}\r\n\r\n.page-header p {\r\n  margin: 0;\r\n  color: var(--muted);\r\n  max-width: 760px;\r\n  line-height: 1.6;\r\n}\r\n\r\n.section-card {\r\n  background: var(--surface);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  box-shadow: var(--card-shadow);\r\n}\r\n\r\n.small-button {\r\n  border: 1px solid var(--border);\r\n  background: var(--surface-strong);\r\n  color: var(--text);\r\n  border-radius: 8px;\r\n  padding: 10px 16px;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.small-button.active,\r\n.small-button:hover {\r\n  background: var(--button-bg);\r\n  color: var(--button-text);\r\n  border-color: var(--button-border);\r\n}\r\n\r\n.small-button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.social-button-content {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.social-icon {\r\n  width: 14px;\r\n  height: 14px;\r\n  fill: currentColor;\r\n}\r\n\r\n.list-grid,\r\n.card-grid {\r\n  display: grid;\r\n  gap: 16px;\r\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\r\n}\r\n\r\n.card {\r\n  background: var(--surface);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.card:hover {\r\n  border-color: var(--muted-strong);\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.card h3 {\r\n  margin: 0 0 12px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: var(--text);\r\n}\r\n\r\n.card p {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  color: var(--muted);\r\n  line-height: 1.5;\r\n}\r\n\r\n.table-wrapper {\r\n  overflow-x: auto;\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  background: var(--surface);\r\n}\r\n\r\n/* On touch devices hide horizontal scroll and ensure tables wrap into our mobile layout */\r\n.is-mobile .table-wrapper {\r\n  overflow-x: hidden;\r\n  border: 0px !important;\r\n}\r\n\r\ntable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 14px;\r\n}\r\n\r\ntbody tr {\r\n  border-bottom: 1px solid var(--border);\r\n  transition: background-color 0.2s;\r\n}\r\n\r\ntbody tr:hover {\r\n  background-color: rgba(51, 65, 85, 0.5);\r\n}\r\n\r\nbody.light-theme tbody tr:hover {\r\n  background-color: rgba(15, 23, 42, 0.05);\r\n}\r\n\r\ntd, th {\r\n  text-align: left;\r\n  padding: 14px 16px;\r\n}\r\n\r\nth {\r\n  background: var(--surface-strong);\r\n  color: var(--muted-strong);\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\ntd {\r\n  color: var(--text);\r\n}\r\n\r\ninput, select {\r\n  width: 100%;\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  padding: 12px 14px;\r\n  background: var(--surface);\r\n  color: var(--text);\r\n  font-size: 14px;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\ninput:focus, select:focus {\r\n  outline: none;\r\n  border-color: var(--button-bg);\r\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\r\n}\r\n\r\ninput::placeholder,\r\nselect::placeholder {\r\n  color: var(--muted);\r\n}\r\n\r\ninput[type='date'] {\r\n  max-width: 220px;\r\n}\r\n\r\n.form-row {\r\n  display: grid;\r\n  gap: 18px;\r\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.form-row label {\r\n  display: grid;\r\n  gap: 8px;\r\n  color: var(--text);\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n\r\n.primary-button {\r\n  appearance: none;\r\n  border: 1px solid var(--button-border);\r\n  background: var(--button-bg);\r\n  color: var(--button-text);\r\n  border-radius: 8px;\r\n  padding: 12px 18px;\r\n  cursor: pointer;\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.toast-stack {\r\n  position: fixed;\r\n  bottom: 24px;\r\n  right: 24px;\r\n  z-index: 3000;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.toast {\r\n  position: relative;\r\n  min-width: 240px;\r\n  max-width: 320px;\r\n  border-radius: 12px;\r\n  padding: 12px 40px 12px 14px;\r\n  background: var(--surface);\r\n  border: 1px solid var(--border);\r\n  box-shadow: var(--card-shadow);\r\n}\r\n\r\n.toast.success {\r\n  border-color: #22c55e;\r\n}\r\n\r\n.toast.error {\r\n  border-color: #ef4444;\r\n}\r\n\r\n.toast-close {\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 8px;\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--muted-strong);\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n  line-height: 1;\r\n}\r\n\r\n.toast-title {\r\n  font-weight: 700;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.driver-profile-card {\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  padding: 14px;\r\n  background: var(--surface-strong);\r\n}\r\n\r\n.driver-profile-socials {\r\n  display: flex;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n  margin-top: 8px;\r\n}\r\n\r\n.driver-profile-socials a {\r\n  color: var(--secondary-color);\r\n  font-weight: 600;\r\n}\r\n\r\n.primary-button:hover:not(:disabled) {\r\n  background: var(--button-border);\r\n  box-shadow: 0 8px 16px rgba(79, 70, 229, 0.2);\r\n}\r\n\r\n.primary-button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.empty-state {\r\n  color: var(--muted);\r\n  padding: 40px 20px;\r\n  text-align: center;\r\n  font-size: 15px;\r\n}\r\n\r\n.status-pill {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 12px;\r\n  border-radius: 999px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  background: color-mix(in srgb, var(--secondary-color) 16%, transparent);\r\n  color: var(--secondary-color);\r\n}\r\n\r\n.badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 28px;\r\n  height: 28px;\r\n  border-radius: 50%;\r\n  background: var(--button-bg);\r\n  color: var(--button-text);\r\n  font-weight: 700;\r\n  font-size: 12px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .app-main {\r\n    padding: 16px;\r\n  }\r\n\r\n  .form-row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .list-grid,\r\n  .card-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  /* Mobile: convert tables into card-like rows with labels */\r\n  table.responsive-table,\r\n  .results-standings-table.responsive-table,\r\n  .table-wrapper {\r\n    border: 0;\r\n  }\r\n\r\n  .responsive-table thead {\r\n    display: none;\r\n  }\r\n\r\n  .responsive-table tbody tr {\r\n    display: block;\r\n    margin: 10px 0;\r\n    border: 1px solid var(--border);\r\n    border-radius: 8px;\r\n    background: var(--surface-strong);\r\n    padding: 3px;\r\n  }\r\n\r\n  .responsive-table td {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 8px 6px;\r\n    border: none;\r\n  }\r\n\r\n  .responsive-table td::before {\r\n    content: attr(data-label);\r\n    color: var(--muted);\r\n    margin-right: 8px;\r\n    flex: 0 0 35%;\r\n    text-align: left;\r\n    font-weight: 600;\r\n  }\r\n\r\n  /* Values should be left aligned and sit close to the label */\r\n  .responsive-table td span {\r\n    display: inline-block;\r\n    text-align: left;\r\n    flex: 1 1 auto;\r\n    color: var(--text);\r\n  }\r\n}\r\n\r\n/* Drivers table: hide Last Seen (4th column) on small screens */\r\n@media (max-width: 768px) {\r\n  .drivers-condensed thead th:nth-child(4),\r\n  .drivers-condensed tbody td:nth-child(4) {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* Past championships table: hide Start and Races columns on small screens */\r\n@media (max-width: 640px) {\r\n  .past-championships-table thead th:nth-child(2),\r\n  .past-championships-table tbody td:nth-child(2),\r\n  .past-championships-table thead th:nth-child(4),\r\n  .past-championships-table tbody td:nth-child(4) {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .drivers-condensed tbody tr {\r\n    cursor: pointer;\r\n  }\r\n\r\n  .home-hero {\r\n    padding: 18px;\r\n  }\r\n\r\n  .home-hero .section-card h1 {\r\n    font-size: 1.6rem;\r\n  }\r\n\r\n  .home-hero .primary-button {\r\n    width: 100%;\r\n    padding: 12px 14px;\r\n  }\r\n\r\n  .hotlap-responsive tbody tr {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: auto auto;\r\n    gap: 2px 4px;\r\n    align-items: center;\r\n    padding: 3x;\r\n    border: 1px solid var(--border);\r\n    border-radius: 8px;\r\n    background: var(--surface-strong);\r\n    margin: 8px 0;\r\n  }\r\n\r\n  .hotlap-responsive tbody tr td {\r\n    display: block;\r\n    padding: 4px 6px;\r\n    border: none;\r\n  }\r\n\r\n  .hotlap-responsive tbody tr td:nth-child(2) { /* Driver */\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n  }\r\n\r\n  .hotlap-responsive tbody tr td:nth-child(1) { /* Track */\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n  }\r\n\r\n  .hotlap-responsive tbody tr td:nth-child(3) { /* Car */\r\n    grid-column: 1 / 2;\r\n    grid-row: 2 / 3;\r\n  }\r\n\r\n  .hotlap-responsive tbody tr td:nth-child(4) { /* Best Lap */\r\n    grid-column: 2 / 3;\r\n    grid-row: 2 / 3;\r\n    text-align: left;\r\n  }\r\n\r\n  /* Reduce badge and position sizes on small screens */\r\n  .position-badge {\r\n    width: 28px;\r\n    height: 28px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .badge {\r\n    min-width: 24px;\r\n    height: 24px;\r\n    font-size: 11px;\r\n  }\r\n}\r\n\r\n/* Apply same mobile layout rules when device is touch-enabled */\r\n.is-mobile table.responsive-table,\r\n.is-mobile .results-standings-table.responsive-table {\r\n  border: 0;\r\n}\r\n\r\n.is-mobile .responsive-table thead {\r\n  display: none;\r\n}\r\n\r\n.is-mobile .responsive-table tbody tr {\r\n  display: block;\r\n  margin: 10px 0;\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  background: var(--surface-strong);\r\n  padding: 12px;\r\n}\r\n\r\n.is-mobile .responsive-table td {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 8px 6px;\r\n  border: none;\r\n}\r\n\r\n.is-mobile .responsive-table td::before {\r\n  content: attr(data-label);\r\n  color: var(--muted);\r\n  margin-right: 8px;\r\n  flex: 0 0 35%;\r\n  text-align: left;\r\n  font-weight: 600;\r\n}\r\n\r\n.is-mobile .responsive-table td span {\r\n  display: inline-block;\r\n  text-align: left;\r\n  flex: 1 1 auto;\r\n  color: var(--text);\r\n}\r\n\r\n/* Hide unwanted columns (Date, Session) on touch devices for hotlap/recent sessions */\r\n.is-mobile .hotlap-responsive thead th:nth-child(5),\r\n.is-mobile .hotlap-responsive tbody td:nth-child(5),\r\n.is-mobile .hotlap-responsive thead th:nth-child(6),\r\n.is-mobile .hotlap-responsive tbody td:nth-child(6) {\r\n  display: none;\r\n}\r\n\r\n/* Also hide Date column in DriverDetail recent sessions (5th column) */\r\n.is-mobile .hotlap-responsive thead th:nth-child(5),\r\n.is-mobile .hotlap-responsive tbody td:nth-child(5) {\r\n  display: none;\r\n}\r\n\r\n/* Provide two-row grid layout on touch devices for hotlap rows */\r\n.is-mobile .hotlap-responsive tbody tr {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  grid-template-rows: auto auto;\r\n  gap: 6px 12px;\r\n  align-items: center;\r\n  padding: 12px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  background: var(--surface-strong);\r\n  margin: 8px 0;\r\n}\r\n\r\n.is-mobile .hotlap-responsive tbody tr td {\r\n  display: block;\r\n  padding: 4px 6px;\r\n  border: none;\r\n}\r\n\r\n.is-mobile .hotlap-responsive tbody tr td:nth-child(2) { /* Driver */\r\n  grid-column: 1 / 2;\r\n  grid-row: 1 / 2;\r\n}\r\n\r\n.is-mobile .hotlap-responsive tbody tr td:nth-child(1) { /* Track */\r\n  grid-column: 2 / 3;\r\n  grid-row: 1 / 2;\r\n}\r\n\r\n.is-mobile .hotlap-responsive tbody tr td:nth-child(3) { /* Car */\r\n  grid-column: 1 / 2;\r\n  grid-row: 2 / 3;\r\n}\r\n\r\n.is-mobile .hotlap-responsive tbody tr td:nth-child(4) { /* Best Lap */\r\n  grid-column: 2 / 3;\r\n  grid-row: 2 / 3;\r\n  text-align: left;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
